<template>
	<div class="wizard-overview">
		<design-2021-apprentice-multistep-form-wizard-form-header-component
			:title="$t('testcenter.overview')"
			:description="description">
		</design-2021-apprentice-multistep-form-wizard-form-header-component>

		<div class="wizard-overview-content">
			<div class="test-name">
				<h4 class="title">{{ steps[0].title }}</h4>
				{{ formData.test.title }}
			</div>

			<div class="students-overview">
				<h4 class="title">{{ steps[1].title }}</h4>
				<ul
					class="students-list"
					v-if="formData.groups.students.length > 0">
					<li class="header">{{$t('common.students')}}</li>
					<li
						class="teacher"
						v-for="student in formData.groups.students"
						:key="student.id">
						<i class="icon fa-fw fad fa-user"></i>
						{{ student.full_name }}
					</li>
				</ul>

				<div
					class="groups-overview"
					v-if="!!formData.groups.las_groups.length || !!formData.groups.main_groups.length">
					<ul
						class="las-groups-list"
						v-if="formData.groups.las_groups.length > 0">
						<li class="header">{{$t('accounts.groups')}}</li>
						<li
							v-for="group of formData.groups.las_groups"
							:key="group.id">
							<i class="icon fa-fw fad fa-users"></i>
							{{ group.name }}
						</li>
					</ul>

					<ul
						class="main-groups-list"
						v-if="formData.groups.main_groups.length > 0">
						<li class="header">{{$t('accounts.main_groups')}}</li>
						<li
							v-for="group of formData.groups.main_groups"
							:key="group.id">
							<i class="icon fa-fw fad fa-users"></i>
							{{ group.name }}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'design-2021-test-center-issuing-wizard-overview-component',
		props: {
			formData: {
				type: Object,
				required: true,
			},
			steps: {
				type: Array,
				required: true,
			},
		},
		data() {
			return {
				description: this.$t('testcenter.description_send_test')
			};
		},
	};
</script>

<style scoped lang="scss">
	ul {
		list-style: none;
		padding: 0;
	}

	.test-name,
	.students-overview {
		background-color: $secondary-background-color;
		border-radius: $border-radius-content;
		padding: map-get($grid-gutter-spacing, 'fifteen');
		font-size: $base-font-size;
		line-height: 1.5;
		margin-bottom: $grid-gutter-width;
	}

	.test-name {
		.title {
			border-bottom: 2px solid $border-color;
			padding-bottom: map-get($grid-gutter-spacing, 'eight');
		}
	}

	.groups-overview {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		gap: $grid-gutter-width map-get($grid-gutter-spacing, 'sixty');
	}

	.students-list,
	.groups-list {
		.header {
			font-size: $base-font-size;
			font-weight: $font-weight-medium;
		}

		.icon {
			color: $primary;
			font-size: $base-font-size;
			margin-right: map-get($grid-gutter-spacing, 'ten');
		}
	}

	.students-list {
		display: flex;
		flex-wrap: wrap;
		gap: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'ten');

		.header {
			flex: 1 0 100%;
		}

		.icon {
			margin-right: 0;
		}
	}
</style>
